import { Typography } from "antd";
import type { ReactNode } from "react";
import { FormattedMessage } from "react-intl";

export type FormSectionLabel = {
  titleIntlKey: string;
  descriptionIntlKey: string | { key: string; [variable: string]: string | ReactNode };
};

const FormHelpSectionLabelView = ({ titleIntlKey, descriptionIntlKey }: FormSectionLabel) => {
  const { key: descriptionKey, ...descriptionValues } =
    typeof descriptionIntlKey === "string" ? { key: descriptionIntlKey } : descriptionIntlKey;

  return (
    <div>
      <Typography.Text strong>
        <FormattedMessage id={titleIntlKey} />
      </Typography.Text>
      <br />
      {descriptionKey && (
        <Typography.Text>
          <FormattedMessage id={descriptionKey} values={descriptionValues} />
        </Typography.Text>
      )}
    </div>
  );
};

export default FormHelpSectionLabelView;
